const VISITOR_CODE_KEY = "kameleoonVisitorCode";
const VISITOR_CODE_MAX_AGE = 380 * 24 * 60 * 60; // seconds, mirrors the SDK's own cookie lifetime

// The widget is a cross-origin iframe: browsers block third-party cookie
// writes here, so the SDK (which persists its visitor code ONLY in a cookie)
// can neither keep its own code between sessions nor read one we write for
// it. Instead we keep the merchant page's code (delivered by the shim via
// iframe query param + postMessage) in module memory and pass it explicitly
// to every SDK call — exposure then lands on the same visitor as the main
// tag's goals. Persistence comes from the first-party cookie on the
// merchant's own domain.
let externalVisitorCode = null;

const isValidVisitorCode = (code) =>
  typeof code === "string" && /^[A-Za-z0-9_-]{1,255}$/.test(code);

export const getExternalKameleoonVisitorCode = () => externalVisitorCode;

export const syncKameleoonVisitorCode = (code) => {
  if (!isValidVisitorCode(code)) {
    return false;
  }
  externalVisitorCode = code;
  // Best effort for browsers that still allow third-party cookies: align the
  // SDK's own storage too (SameSite=None; Secure is required in an iframe).
  try {
    localStorage.removeItem(VISITOR_CODE_KEY);
  } catch (error) {
    // storage unavailable — the in-memory code above is enough
  }
  document.cookie = `${VISITOR_CODE_KEY}=${encodeURIComponent(code)}; path=/; max-age=${VISITOR_CODE_MAX_AGE}; SameSite=None; Secure`;
  return true;
};

export const syncKameleoonVisitorCodeFromQuery = () => {
  const code = new URLSearchParams(window.location.search).get(VISITOR_CODE_KEY);
  return code ? syncKameleoonVisitorCode(code) : false;
};
